<template>
  <div class="machine-counter-wrapper not-ready" v-if="componentVisible">
    <hr />
    Noch {{ numberToWord[pagesToFinish] }}<br />bis zum Zwischenergebnis
  </div>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      surveyPages: 4, // TODO put in config or somewhere global
      numberToWord: {
        1: 'eine Frage',
        2: 'zwei Fragen',
        3: 'drei Fragen'
      }
    }
  },
  computed: {
    pagesToFinish() {
      return this.surveyPages - this.currentPage
    },
    componentVisible() {
      return this.currentPage > 0 && this.currentPage < 4
    }
  }
}
</script>
